import Vue from 'vue'
import App from './App.vue'
import router from "@/router"
import store from "@/store"
import '@/plugins/element-ui'
import '@/styles/font.css'
import '@/styles/iconfont.css'
import "@/styles/index.css"
import "@/styles/margin.css"
import "@/styles/flex.css"
import "@/styles/element-ui.css"
import directUploadMultiple from '@/components/directUpload/index.vue';
import directUploadOne from '@/components/directUploadOne/index.vue';

// 防抖指令
import debounce from '@/utils/directive/index'
Vue.component('directUploadMultiple', directUploadMultiple);
Vue.component('directUploadOne', directUploadOne);

Vue.use(debounce)

Vue.config.productionTip = false
Vue.config.silent = true
//事件总线
Vue.prototype.$bus = new Vue()
const vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

export default vue
